/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MarketItemTransactionLogData model module.
 * @module model/MarketItemTransactionLogData
 * @version 1.0
 */
class MarketItemTransactionLogData {
    /**
     * Constructs a new <code>MarketItemTransactionLogData</code>.
     * @alias module:model/MarketItemTransactionLogData
     */
    constructor() { 
        
        MarketItemTransactionLogData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>MarketItemTransactionLogData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MarketItemTransactionLogData} obj Optional instance to populate.
     * @return {module:model/MarketItemTransactionLogData} The populated <code>MarketItemTransactionLogData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MarketItemTransactionLogData();

            if (data.hasOwnProperty('listingNo')) {
                obj['listingNo'] = ApiClient.convertToType(data['listingNo'], 'Number');
            }
            if (data.hasOwnProperty('tokenType')) {
                obj['tokenType'] = ApiClient.convertToType(data['tokenType'], 'Number');
            }
            if (data.hasOwnProperty('price')) {
                obj['price'] = ApiClient.convertToType(data['price'], 'Number');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'Number');
            }
            if (data.hasOwnProperty('registedAt')) {
                obj['registedAt'] = ApiClient.convertToType(data['registedAt'], 'Date');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('itemCount')) {
                obj['itemCount'] = ApiClient.convertToType(data['itemCount'], 'Number');
            }
            if (data.hasOwnProperty('itemId')) {
                obj['itemId'] = ApiClient.convertToType(data['itemId'], 'Number');
            }
            if (data.hasOwnProperty('itemName')) {
                obj['itemName'] = ApiClient.convertToType(data['itemName'], 'String');
            }
            if (data.hasOwnProperty('itemType')) {
                obj['itemType'] = ApiClient.convertToType(data['itemType'], 'Number');
            }
            if (data.hasOwnProperty('level')) {
                obj['level'] = ApiClient.convertToType(data['level'], 'Number');
            }
            if (data.hasOwnProperty('coinType')) {
                obj['coinType'] = ApiClient.convertToType(data['coinType'], 'Number');
            }
            if (data.hasOwnProperty('gemColor')) {
                obj['gemColor'] = ApiClient.convertToType(data['gemColor'], 'Number');
            }
            if (data.hasOwnProperty('gemEffect')) {
                obj['gemEffect'] = ApiClient.convertToType(data['gemEffect'], 'Number');
            }
            if (data.hasOwnProperty('gemEffectValue')) {
                obj['gemEffectValue'] = ApiClient.convertToType(data['gemEffectValue'], 'Number');
            }
            if (data.hasOwnProperty('upgradeItemId')) {
                obj['upgradeItemId'] = ApiClient.convertToType(data['upgradeItemId'], 'Number');
            }
            if (data.hasOwnProperty('sellerEmail')) {
                obj['sellerEmail'] = ApiClient.convertToType(data['sellerEmail'], 'String');
            }
            if (data.hasOwnProperty('sellerAccountNo')) {
                obj['sellerAccountNo'] = ApiClient.convertToType(data['sellerAccountNo'], 'Number');
            }
            if (data.hasOwnProperty('buyerEmail')) {
                obj['buyerEmail'] = ApiClient.convertToType(data['buyerEmail'], 'String');
            }
            if (data.hasOwnProperty('buyerAccountNo')) {
                obj['buyerAccountNo'] = ApiClient.convertToType(data['buyerAccountNo'], 'Number');
            }
            if (data.hasOwnProperty('transactedAt')) {
                obj['transactedAt'] = ApiClient.convertToType(data['transactedAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MarketItemTransactionLogData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MarketItemTransactionLogData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['itemName'] && !(typeof data['itemName'] === 'string' || data['itemName'] instanceof String)) {
            throw new Error("Expected the field `itemName` to be a primitive type in the JSON string but got " + data['itemName']);
        }
        // ensure the json data is a string
        if (data['sellerEmail'] && !(typeof data['sellerEmail'] === 'string' || data['sellerEmail'] instanceof String)) {
            throw new Error("Expected the field `sellerEmail` to be a primitive type in the JSON string but got " + data['sellerEmail']);
        }
        // ensure the json data is a string
        if (data['buyerEmail'] && !(typeof data['buyerEmail'] === 'string' || data['buyerEmail'] instanceof String)) {
            throw new Error("Expected the field `buyerEmail` to be a primitive type in the JSON string but got " + data['buyerEmail']);
        }

        return true;
    }


}



/**
 * @member {Number} listingNo
 */
MarketItemTransactionLogData.prototype['listingNo'] = undefined;

/**
 * @member {Number} tokenType
 */
MarketItemTransactionLogData.prototype['tokenType'] = undefined;

/**
 * @member {Number} price
 */
MarketItemTransactionLogData.prototype['price'] = undefined;

/**
 * @member {Number} status
 */
MarketItemTransactionLogData.prototype['status'] = undefined;

/**
 * @member {Date} registedAt
 */
MarketItemTransactionLogData.prototype['registedAt'] = undefined;

/**
 * @member {Number} accountNo
 */
MarketItemTransactionLogData.prototype['accountNo'] = undefined;

/**
 * @member {Number} itemCount
 */
MarketItemTransactionLogData.prototype['itemCount'] = undefined;

/**
 * @member {Number} itemId
 */
MarketItemTransactionLogData.prototype['itemId'] = undefined;

/**
 * @member {String} itemName
 */
MarketItemTransactionLogData.prototype['itemName'] = undefined;

/**
 * @member {Number} itemType
 */
MarketItemTransactionLogData.prototype['itemType'] = undefined;

/**
 * @member {Number} level
 */
MarketItemTransactionLogData.prototype['level'] = undefined;

/**
 * @member {Number} coinType
 */
MarketItemTransactionLogData.prototype['coinType'] = undefined;

/**
 * @member {Number} gemColor
 */
MarketItemTransactionLogData.prototype['gemColor'] = undefined;

/**
 * @member {Number} gemEffect
 */
MarketItemTransactionLogData.prototype['gemEffect'] = undefined;

/**
 * @member {Number} gemEffectValue
 */
MarketItemTransactionLogData.prototype['gemEffectValue'] = undefined;

/**
 * @member {Number} upgradeItemId
 */
MarketItemTransactionLogData.prototype['upgradeItemId'] = undefined;

/**
 * @member {String} sellerEmail
 */
MarketItemTransactionLogData.prototype['sellerEmail'] = undefined;

/**
 * @member {Number} sellerAccountNo
 */
MarketItemTransactionLogData.prototype['sellerAccountNo'] = undefined;

/**
 * @member {String} buyerEmail
 */
MarketItemTransactionLogData.prototype['buyerEmail'] = undefined;

/**
 * @member {Number} buyerAccountNo
 */
MarketItemTransactionLogData.prototype['buyerAccountNo'] = undefined;

/**
 * @member {Date} transactedAt
 */
MarketItemTransactionLogData.prototype['transactedAt'] = undefined;






export default MarketItemTransactionLogData;

